import { getPartnerApps, getPromotions, PromotionOrderBy } from '@atlassian/mpac-api-client';
import { DynamicTableUtils, hooks, log } from '@atlassian/mpac-utils';
import camelCase from 'lodash/camelCase';
import flatten from 'lodash/flatten';
import sortBy from 'lodash/sortBy';
import startCase from 'lodash/startCase';
import uniq from 'lodash/uniq';
import { PromotionsFilters } from "./PromotionsTable/PromotionsTable.types";
export const usePromotions = (mpacBaseUrl, partnerId, filters, sortByValue, offset) => {
  let isActive = false;
  let appKey = '';
  let hostingType = '';
  filters.forEach(filterBy => {
    if (filterBy.type === PromotionsFilters.APPS) {
      appKey = filterBy.value;
    }

    if (filterBy.type === PromotionsFilters.HOSTING) {
      hostingType = filterBy.value;
    }

    if (filterBy.type === PromotionsFilters.ACTIVE) {
      isActive = true;
    }
  });
  const searchParams = {
    limit: DynamicTableUtils.DEFAULT_PAGE_LIMIT,
    offset,
    'app-key': appKey,
    'hosting-type': hostingType,
    'active-only': isActive,
    'order-by': Object.keys(PromotionOrderBy).find(key => PromotionOrderBy[key] === sortByValue.orderBy),
    ascending: sortByValue.orderBy ? sortByValue.orderAsc : undefined
  };
  const {
    result,
    error,
    pending
  } = hooks.usePromise(() => getPromotions(mpacBaseUrl, partnerId, searchParams), [appKey, hostingType, isActive, offset, sortByValue]);

  if (error) {
    log.error('PromotionsList/hooks', "Failed to retrieve Promotions List", {
      error
    });
  }

  return {
    pending,
    error,
    promotionsData: result
  };
};
export const usePartnerAppsAndHosting = (mpacBaseUrl, partnerId) => {
  const {
    result,
    error,
    pending
  } = hooks.usePromise(() => getPartnerApps(mpacBaseUrl, partnerId));

  if (error) {
    log.error('PromotionsList/hooks', "Failed to retrieve Partner Apps", {
      error
    });
  }

  let partnerAppsAndHosting = {
    apps: [],
    hostingTypes: []
  };

  if (result) {
    const hostingTypes = flatten(result.map(app => app.compatibleProducts.map(product => product.hostingType)));
    partnerAppsAndHosting = {
      apps: result,
      hostingTypes: sortBy(uniq(hostingTypes))
    };
  }

  return {
    pending,
    error,
    partnerAppsAndHosting
  };
};
export const formatPartnerAppsOptions = (partnerAppsAndHosting, hostingType) => (hostingType ? partnerAppsAndHosting.apps.filter(app => app.compatibleProducts.map(product => product.hostingType).includes(hostingType.value)) : partnerAppsAndHosting.apps).map(app => ({
  label: app.name,
  value: app.key
}));
export const formatPartnerHostingTypesOptions = partnerAppsAndHosting => partnerAppsAndHosting.hostingTypes.map(hosting => ({
  label: startCase(camelCase(hosting)),
  value: hosting
}));